import {
  APPLICANT_TYPES,
  BothTargetType,
  KYC_PERSON_TARGET_TYPES,
  PrimaryTargetType,
  SecondaryTargetType,
} from '../constants';

export const getDocumentsByApplicantType = (documents, applicantType) =>
  documents.filter((document) =>
    applicantType === APPLICANT_TYPES.MAIN
      ? [PrimaryTargetType, BothTargetType].indexOf(
          KYC_PERSON_TARGET_TYPES[document.PersonTargetType],
        ) > -1
      : [SecondaryTargetType, BothTargetType].indexOf(
          KYC_PERSON_TARGET_TYPES[document.PersonTargetType],
        ) > -1,
  );
